import React, { useState, useEffect, useMemo } from 'react';
import Menu from '../menu/menu';
import Warning from '../warning/warning';
import Play from '../play/play';
import Gallery from '../gallery/gallery';
import Chapters from '../chapters/chapters';
import plot from '../../services/plot';
import images from '../../services/photos'

function App() {
  const [position, setPosition] = useState( localStorage.getItem('position') === null ? 0 : parseInt(localStorage.getItem('position')) );
  const [gallery, setGallery] = useState( localStorage.getItem('gallery') === null ? 0 : new Map(JSON.parse(localStorage.getItem('gallery'))) );
  const [galleryWork, setGalleryWork] = useState( localStorage.getItem('galleryWork') === null ? 0 : new Map(JSON.parse(localStorage.getItem('galleryWork'))) );

  useEffect(() => {
    const map = new Map();
    const mapWork = new Map();
    if(gallery === 0){
      for(let key in plot){
        if(plot[key].plot){
        for(let k in plot[key].plot){
          if(plot[key].plot[k].img && plot[key].plot[k].gallery){
        map.set(plot[key].plot[k].img, '0');
        }
        }
        }
        if(plot[key].plotAlt){
        for(let k in plot[key].plotAlt){
          if(plot[key].plotAlt[k].img && plot[key].plotAlt[k].gallery){
        map.set(plot[key].plotAlt[k].img, '0');
        }
        }
        }
        if(plot[key].messages){
        for(let k in plot[key].messages){
          if(plot[key].messages[k].img && plot[key].messages[k].gallery){
        map.set(plot[key].messages[k].img, '0');
        }
        }
        }
        if(plot[key].messagesAlt){
        for(let k in plot[key].messagesAlt){
          if(plot[key].messagesAlt[k].img && plot[key].messagesAlt[k].gallery){
        map.set(plot[key].messagesAlt[k].img, '0');
        }
        }
        }
      }
    }else{
      for(let key in plot){
        if(plot[key].plot){
        for(let k in plot[key].plot){
          if(plot[key].plot[k].img && plot[key].plot[k].gallery && !gallery.has(plot[key].plot[k].img)){
        map.set(plot[key].plot[k].img, '0');
      }else if(plot[key].plot[k].img && plot[key].plot[k].gallery && gallery.has(plot[key].plot[k].img)){
          map.set(plot[key].plot[k].img, gallery.get(plot[key].plot[k].img));
      }
        }
        }
        if(plot[key].plotAlt){
        for(let k in plot[key].plotAlt){
          if(plot[key].plotAlt[k].img && plot[key].plotAlt[k].gallery && !gallery.has(plot[key].plotAlt[k].img)){
        map.set(plot[key].plotAlt[k].img, '0');
      }else if(plot[key].plotAlt[k].img && plot[key].plotAlt[k].gallery && gallery.has(plot[key].plotAlt[k].img)){
          map.set(plot[key].plotAlt[k].img, gallery.get(plot[key].plotAlt[k].img));
      }
        }
        }
        if(plot[key].messages){
        for(let k in plot[key].messages){
          if(plot[key].messages[k].img && plot[key].messages[k].gallery && !gallery.has(plot[key].messages[k].img)){
        map.set(plot[key].messages[k].img, '0');
      }else if(plot[key].messages[k].img && plot[key].messages[k].gallery && gallery.has(plot[key].messages[k].img)){
          map.set(plot[key].messages[k].img, gallery.get(plot[key].messages[k].img));
      }
        }
        }
        if(plot[key].messagesAlt){
        for(let k in plot[key].messagesAlt){
          if(plot[key].messagesAlt[k].img && plot[key].messagesAlt[k].gallery && !gallery.has(plot[key].messagesAlt[k].img)){
        map.set(plot[key].messagesAlt[k].img, '0');
      }else if(plot[key].messagesAlt[k].img && plot[key].messagesAlt[k].gallery && gallery.has(plot[key].messagesAlt[k].img)){
          map.set(plot[key].messagesAlt[k].img, gallery.get(plot[key].messagesAlt[k].img));
      }
        }
        }
      }
    }
    localStorage.setItem('gallery', JSON.stringify(Array.from(map.entries())));
    setGallery(map);
    if(galleryWork === 0){
      for(let key in images){
        if(images[key].img){
          mapWork.set(images[key].img, '0');
        }
      }
    }else{
      for(let key in images){
        if(images[key].img){
          if(galleryWork.has(images[key].img)){
            mapWork.set(images[key].img, galleryWork.get(images[key].img))
          }else{
            mapWork.set(images[key].img, '0');
          }
        }
      }
    }
    localStorage.setItem('galleryWork', JSON.stringify(Array.from(mapWork.entries())));
    setGalleryWork(mapWork);
},[]);

  function goPlay(){
setTimeout(go,300);
    function go(){
    localStorage.setItem('position', 2);
    setPosition(2);
  }
  }
  function goMenu(){
    localStorage.setItem('position', 1);
    setPosition(1);
  }
  function goSelectChapter(){
    localStorage.setItem('position', 3);
    setPosition(3);
  }
  function goToGallery(){
    localStorage.setItem('position', 4);
    setPosition(4);
  }

  if(position !== null && position === 1){
    return (
      <Menu goPlay={goPlay} goSelectChapter={goSelectChapter} goToGallery={goToGallery}/>
  );
  }
  if(position !== null && position === 2){
    return (
      <Play currentDay={plot} endPlay={goMenu} gallery={gallery} setGallery={setGallery} galleryWork={galleryWork} setGalleryWork={setGalleryWork}/>
  );
  }
  if(position !== null && position === 3){
  return (
    <Chapters goBack={goMenu} goPlay={goPlay}/>
);
}
  if(position !== null && position === 4){
    return (
      <Gallery goBack={goMenu} gallery={gallery} galleryWork={galleryWork}/>
  );
  }
  if(position !== null && position === 0){
    return (
      <Warning  goNext={goMenu} />
  );
  }

}

export default App;
